import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InputField from '../../../commonComponents/formComponents/inputField'
import validate from 'validate.js'
import * as ActionTypes from '../../actions/actionTypes'
import { createLineItemMsgStructure } from '../../util/itemsTabValidation'

const SupplyUnit = ({ invoiceId, merchandiseId, invoiceIndex, lineItemIndex, updateData, saveData, translate, lineItemPattern, validateError }) => {
  const dispatch = useDispatch()
  const supplyUnit = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.supplyUnit) || ''
  const weightUoM = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.weightUoM) ||''
  const supplyUnitErr = useSelector((state) => state?.ValidationErrors.items?.[`invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_supplyUnit`])
 
  return (
    <InputField
      isLabel={false}
      id={`supplyUnit-${invoiceId}-${merchandiseId}`}
      type="number"
      label={translate('SUPPLY_UNIT', { ns: ['default', 'lineItem'] })}
      value={supplyUnit}
      errors={supplyUnitErr && supplyUnitErr?.msg}
      className='field-bg'
      clearInput={false}
      onChange={(value) => updateData({ supplyUnit: value })}
      onBlur={(value) => {
        saveData({ supplyUnit: value || " " })
        // const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_supplyUnit`
        // validateError({[key]:""},{[key]:value},
        //       {[key]:lineItemPattern(invoiceIndex+1, lineItemIndex+1)?.supplyUnit}
        // )
        const key1 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_weightUoM`
        const key2 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_supplyUnit`
        let lineItemErr = validate({ weightUoM: weightUoM, supplyUnit: value },
          { weightUoM: lineItemPattern()?.weightUoM, supplyUnit: lineItemPattern()?.supplyUnit }
        ) || {}
        lineItemErr = createLineItemMsgStructure(lineItemErr, invoiceIndex, lineItemIndex)
        dispatch({
          type: ActionTypes.UPDATE_VALIDATION_ERRORS,
          tabName: 'items',
          payload: { [key1]: "", [key2]: "", ...lineItemErr }
        })
      }}
    />
  )
}

export default SupplyUnit